const isNumberLike = (v) => typeof v === "number" && !Number.isNaN(v) || typeof v === "bigint" && !Number.isNaN(Number(v)) || typeof v === "string" && !Number.isNaN(Number(String(v).trim() || void 0));

export { isNumberLike };
//# sourceMappingURL=isNumberLike.js.map
//# sourceMappingURL=isNumberLike.js.map